import { currencyFormat, formatDateShortMon } from '../../../Functions';

export function HeadCompose(page, rowL, Bk, dataUrl, printed) {
    var doc = Bk;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 25;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop + _space, 50, 23);

    _y += _space;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()

    if (printed) {
        doc.text('Date Printed: ' + formatted_date, 190, _y + _space, null, null, 'right');
    }

    _y += _space * 4;

    doc.text('Authority To Withdraw', 105, _y, null, null, 'center');

    _y += _space;

    return _y;
}

export function HeadingCompose(page, rowL, Bk, data) {
    var doc = Bk;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space;

    // doc.text(20, _y, 'Old Booking Ref');
    // doc.text(65, _y, data.oldBookingRef ? data.oldBookingRef : '');
    // doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'Booking Reference');
    doc.text(160, _y, data.bookingRef ? data.bookingRef : '');
    doc.line(160, _y + 1, 190, _y + 1);

    // _y += _space * 1.5;
    // doc.text(20, _y, 'Booking Reference');
    // doc.text(65, _y, data.bookingRef ? data.bookingRef : '');
    // doc.line(65, _y + 1, 105, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Shipper');
    doc.text(65, _y, data.shipperName ? data.shipperName : '');
    doc.line(65, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Shipper Preferred Name');
    doc.text(75, _y, data.shipperPreferedName ? data.shipperPreferedName : '');
    doc.line(75, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Tel No.');
    doc.text(65, _y, data.shipperContactNum ? data.shipperContactNum.toString() : '');
    doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'Contact Person');
    var person = doc.splitTextToSize(data.shipperContactPerson ? data.shipperContactPerson : '', 40);
    doc.text(150, _y, person);
    if (person.length > 1) {
        _y += _space * (person.length - 1);
    }
    doc.line(150, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Consignee');
    doc.text(65, _y, data.consigneeName ? data.consigneeName : '');
    doc.line(65, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Consignee Preferred Name');
    doc.text(80, _y, data.consigneePreferedName ? data.consigneePreferedName : '');
    doc.line(80, _y + 1, 190, _y + 1);

    return _y;
}

export function VesselCompose(page, rowL, Bk, data, addData) {
    var doc = Bk;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.5;

    doc.text(20, _y, 'Estimated Vessel');
    doc.text(65, _y, data.voyageSchedule.vessel ? data.voyageSchedule.vessel : '');
    doc.line(65, _y + 1, 105, _y + 1);

    if (data.voyageSchedule.actualVessel) {
        doc.text(115, _y, 'Final Vessel');
        doc.text(150, _y, data.voyageSchedule.actualVessel ? data.voyageSchedule.actualVessel : '');
        doc.line(150, _y + 1, 190, _y + 1);
    }

    _y += _space * 1.5;
    doc.text(20, _y, 'Origin');
    doc.text(65, _y, data.originBranchName ? data.originBranchName : '');
    doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'Destination');
    doc.text(150, _y, data.destinationBranchName ? data.destinationBranchName : '');
    doc.line(150, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'ETD');
    doc.text(65, _y, data.voyageSchedule.estimatedTimeDeparture ? formatDateShortMon(data.voyageSchedule.estimatedTimeDeparture) : '');
    doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'ETA');
    doc.text(150, _y, data.voyageSchedule.estimatedTimeArrival ? formatDateShortMon(data.voyageSchedule.estimatedTimeArrival) : '');
    doc.line(150, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'CY Delivery (Laden)');
    doc.text(65, _y, addData.cyLadenName ? addData.cyLadenName : '');
    doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'CY Pull-out \n (empty)');
    
    // eslint-disable-next-line
    data.cy.map(cy => {
        doc.text(150, _y, cy.name);
        _y += _space;
    })

    // _y += _space * 1.5;
    doc.text(20, _y, 'Cut-Off');
    doc.text(65, _y, addData.cutOff ? formatDateShortMon(addData.cutOff) : '');
    doc.line(65, _y + 1, 105, _y + 1);
    
    doc.text(115, _y, 'Stuffing');
    doc.text(150, _y, data.isStuffing && data.isStuffing === true ? 'Yes' : 'No');
    doc.line(150, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Mode of Delivery');
    doc.text(65, _y, data.modeOfDeliveryName ? data.modeOfDeliveryName : '');
    doc.line(65, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'Mode of Payment');
    doc.text(150, _y, data.modeOfPayment ? data.modeOfPayment : '');
    doc.line(150, _y + 1, 190, _y + 1);

    return _y;
}

export function CommodityCompose(page, rowL, Bk, data) {
    var doc = Bk;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.5;

    doc.text(20, _y, 'Commodity');
    doc.text(65, _y, data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '');
    doc.line(65, _y + 1, 190, _y + 1);

    _y += _space * 1.5;
    doc.text(20, _y, 'Remarks');
    doc.text(65, _y, data.remarks ? data.remarks : '');
    doc.line(65, _y + 1, 190, _y + 1);
    // other goods content

    _y += _space * 2.5;

    doc.text(20, _y, 'Qty');
    doc.text(40, _y, 'Unit');
    doc.text(65, _y, 'Cargo Wt');
    doc.text(100, _y, 'Packaging');
    doc.text(150, _y, 'Declared Value');
    doc.line(20, _y + 1, 190, _y + 1);

    _y += _space;
    doc.text(20, _y, data.quantity ? data.quantity.toString() : '0');
    doc.text(40, _y, data.unit ? data.unit : '');
    doc.text(65, _y, data.cargoWeight ? data.cargoWeight.toString() : '0');
    doc.text(100, _y, data.packagingOthers && data.packagingOthers !== "" ? data.packagingOthers : data.packaging ? data.packaging : '');
    doc.text(150, _y, data.declaredValue ? 'P' + currencyFormat(data.declaredValue) : '0');
    doc.line(20, _y + 1, 190, _y + 1);

    _y += _space * 1.5;

    return _y;
}

export function FinalCompose(page, rowL, Bk, data, user, addData) {
    var doc = Bk;
    var _y = rowL;
    var _space = page.spacingunit;

    if (data.modeOfDeliveryName === "Pier-To-Pier" || data.modeOfDeliveryName === "Pier-To-Door") {
        doc.text(20, _y, 'Releasing Type');
        doc.text(55, _y, addData.releaseType ? addData.releaseType : '');
        doc.line(55, _y + 1, 190, _y + 1);
    }
    _y += _space * 1.5;

    if (data.modeOfDeliveryName === "Door-To-Pier" || data.modeOfDeliveryName === "Door-To-Door") {
        doc.text(20, _y, 'Authorized Trucker');
        doc.text(65, _y, addData.truckerName ? addData.truckerName : '');
        doc.line(65, _y + 1, 190, _y + 1);
        _y += _space;
        doc.text(20, _y, 'Plate Number');
        doc.text(65, _y, addData.plateNum ? addData.plateNum : '');
        doc.line(65, _y + 1, 190, _y + 1);
        _y += _space;
        doc.text(20, _y, 'Driver');
        doc.text(65, _y, addData.driver ? addData.driver : '');
        doc.line(65, _y + 1, 190, _y + 1);
    }
    else {
        doc.text(20, _y, 'Trucker');
        doc.text(55, _y, addData.truckerName ? addData.truckerName : '');
        doc.line(55, _y + 1, 190, _y + 1);
        _y += _space;
        doc.text(20, _y, 'Plate Number');
        doc.text(55, _y, addData.plateNum ? addData.plateNum : '');
        doc.line(55, _y + 1, 190, _y + 1);
        _y += _space;
        doc.text(20, _y, 'Driver');
        doc.text(55, _y, addData.driver ? addData.driver : '');
        doc.line(55, _y + 1, 190, _y + 1);
    }

    _y += _space * 2;

    doc.text(115, _y, 'Issued By');
    doc.text(140, _y, user.name ? user.name : '');
    doc.line(140, _y + 1, 190, _y + 1);

    // doc.text(20, _y, 'CY Pull-out \n (empty)');

    // // eslint-disable-next-line
    // data.cy.map(cy => {
    //     doc.text(65, _y, cy.name);
    //     _y += _space;
    // })

    _y += _space * 2;

    var splitTitle = doc.splitTextToSize('NOTE: Please notify our CSR Representative at ' + data.bookingBranchTelNum + ' upon '
        + 'receipt of this acknowledgment, should there be any incorrect information stipulated above. Non-receipt of feedback ' 
        + 'assumes that all information is correct and Ocean Transport will not be held liable.', 150);

    doc.text(20, _y, splitTitle);

    _y += _space * splitTitle.length;

    _y += _space * 3;

    doc.text(20, _y, 'Container No');
    doc.line(50, _y + 1, 105, _y + 1);

    doc.text(115, _y, 'Checker');
    doc.line(135, _y + 1, 190, _y + 1);
    _y += _space * 1.2;
    doc.text(132, _y, 'Signature over Printed Name');
}